import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../store/store';
import {getAutoGainControl, getSelectedMicrophone, getSelectedSpeaker, setSelectedMicrophoneDevice, setSelectedSpeakerDevice} from '../../../store/features/calls/dialerSlice';
import {
    answerCall,
    endCall,
    rejectCall,
    sendDtmf,
    setSipOutputDevice,
    switchSipMicrophone,
    toggleHold,
    toggleMuted,
} from '../../../components/Dialer/services/sipService';
import {buildAudioConstraints} from '../../../components/Dialer/hooks/audioConstraints';

export interface PhoneActions {
    readonly answer: () => void;
    readonly decline: () => void;
    readonly end: () => void;
    readonly toggleMute: () => void;
    readonly toggleHold: () => void;
    readonly dtmf: (digit: string) => void;
    readonly setOutput: (deviceId: string) => void;
    readonly setMicrophone: (deviceId: string) => void;
    readonly speaker: string;
}

export const usePhoneActions = (): PhoneActions => {
    const dispatch = useAppDispatch();
    const microphone = useSelector(getSelectedMicrophone);
    const autoGainControl = useSelector(getAutoGainControl);
    const speaker = useSelector(getSelectedSpeaker);
    return useMemo(() => ({
        answer: () => void answerCall(dispatch, {mediaConstraints: {audio: buildAudioConstraints(microphone, autoGainControl), video: false}}, speaker),
        decline: () => rejectCall(dispatch),
        end: () => endCall(dispatch),
        toggleMute: () => toggleMuted(),
        toggleHold: () => toggleHold(),
        dtmf: (digit: string) => sendDtmf(digit),
        setOutput: (deviceId: string) => {
            dispatch(setSelectedSpeakerDevice(deviceId));
            void setSipOutputDevice(deviceId);
        },
        setMicrophone: (deviceId: string) => {
            dispatch(setSelectedMicrophoneDevice(deviceId));
            void switchSipMicrophone(deviceId, autoGainControl);
        },
        speaker: speaker ?? '',
    }), [autoGainControl, dispatch, microphone, speaker]);
};
